import { useRef, useState } from 'react';
import { AssetItemDto } from '@api/Api';

export default function useAssetSelection(query: {
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => Promise<any>;
  data?: {
    pages: { edges: { node: AssetItemDto; cursor: string }[] }[];
  };
}) {
  const [selected, setSelected] = useState<
    { node: AssetItemDto; cursor: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const queryRef = useRef(query);
  queryRef.current = query;

  const onSelectAll = async () => {
    if (selected.length) {
      setSelected([]);
      return;
    }
    setLoading(true);
    let q = queryRef.current;
    while (q.hasNextPage) {
      q = await q.fetchNextPage();
    }
    setSelected(q.data?.pages.flatMap((x) => x.edges) ?? []);
    setLoading(false);
  };

  const setSelectedItems = async (
    ids: string[],
    items: { node: AssetItemDto; cursor: string }[],
    isAllSelect: boolean
  ) => {
    let q = queryRef.current;
    if (isAllSelect && ids.length) {
      setLoading(true);
      while (q.hasNextPage) {
        q = await q.fetchNextPage();
      }
      setLoading(false);
    }
    setSelected((prev) => {
      const isDeselect =
        isAllSelect &&
        (!ids.length || prev.some((x) => ids.includes(x.node.id)));
      if (isDeselect) return [];
      if (isAllSelect) {
        return q.data?.pages.flatMap((x) => x.edges) ?? [];
      }
      const newItems = items.filter(
        (x) => !prev.some((y) => x.node.id === y.node.id)
      );
      return [...prev, ...newItems].filter((x) => ids.includes(x.node.id));
    });
  };

  return {
    selected,
    setSelected,
    loading,
    onSelectAll,
    setSelectedItems
  };
}
